import { Action } from 'redux';

import { ChangeSubscriptionDataCondition, ChangeSubscriptionsFormat, ChangeSubscriptionsFrequency, ChangeSubscriptionsSchedule, ChangeSubscriptionSubject, DeleteSubscriptions, ResumeSubscription } from '../../app/actions/AppActionTypes';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';

export interface ChangeSubscriptionSubjectAction extends Action {
  subscription: ISubscriptionInfo;
}

export function changeSubscriptionSubject(subscription: ISubscriptionInfo): ChangeSubscriptionSubjectAction {
  return {
    type: ChangeSubscriptionSubject,
    subscription
  };
}

export interface ChangeSubscriptionsScheduleAction extends Action {
  subscriptions: ISubscriptionInfo[];
}

export function changeSubscriptionsSchedule(subscriptions: ISubscriptionInfo[]): ChangeSubscriptionsScheduleAction {
  return {
    type: ChangeSubscriptionsSchedule,
    subscriptions
  };
}

export interface ChangeSubscriptionDataConditionAction extends Action {
  subscription: ISubscriptionInfo;
}

export function changeSubscriptionDataCondition(subscription: ISubscriptionInfo): ChangeSubscriptionDataConditionAction {
  return {
    type: ChangeSubscriptionDataCondition,
    subscription
  };
}

export interface DeleteSubscriptionsAction extends Action {
  subscriptions: ISubscriptionInfo[];
}

export function deleteSubscriptions(subscriptions: ISubscriptionInfo[]): DeleteSubscriptionsAction {
  return {
    type: DeleteSubscriptions,
    subscriptions
  };
}

export interface ResumeSubscriptionAction extends Action {
  subscription: ISubscriptionInfo;
}

export function resumeSubscription(subscription: ISubscriptionInfo): ResumeSubscriptionAction {
  return {
    type: ResumeSubscription,
    subscription
  };
}

export interface ChangeSubscriptionsFormatAction extends Action {
  subscriptions: ISubscriptionInfo[];
}

export function changeSubscriptionsFormat(subscriptions: ISubscriptionInfo[]): ChangeSubscriptionsFormatAction {
  return {
    type: ChangeSubscriptionsFormat,
    subscriptions
  };
}

export interface ChangeSubscriptionsFrequencyAction extends Action {
  subscriptions: ISubscriptionInfo[];
}

export function changeSubscriptionsFrequency(subscriptions: ISubscriptionInfo[]): ChangeSubscriptionsFrequencyAction {
  return {
    type: ChangeSubscriptionsFrequency,
    subscriptions
  };
}
